/**
 * Test to update the landing experience, to better match their intent:
 * https:www.notion.so/faire/Simplified-SEM-Landing-Page-140387f040194daab66177858d288d3e?pvs=4
 */
export const ENABLE_SEM_SIMPLIFIED_LP_TEST_101124 = 'ENABLE_SEM_SIMPLIFIED_LP_TEST_101124';
